// extracted by mini-css-extract-plugin
module.exports = {"page":"Page-module--page--1iLrC"};